module.exports = __webpack_public_path__ + "media/dang-surprise.ddce9a2b.mp3";